import { render } from "./BuildSpecial.vue?vue&type=template&id=157d27ba&scoped=true&ts=true"
import script from "./BuildSpecial.vue?vue&type=script&lang=ts"
export * from "./BuildSpecial.vue?vue&type=script&lang=ts"

import "./BuildSpecial.vue?vue&type=style&index=0&id=157d27ba&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157d27ba"]])

export default __exports__